var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01641 0.140625C9.71669 0.140625 10.2844 0.708314 10.2844 1.40859V7.74717L16.6242 7.74844C17.3245 7.74844 17.8922 8.31613 17.8922 9.01641C17.8922 9.71669 17.3245 10.2844 16.6242 10.2844L10.2844 10.2831V16.6242C10.2844 17.3245 9.71669 17.8922 9.01641 17.8922C8.31613 17.8922 7.74844 17.3245 7.74844 16.6242V10.2831L1.40859 10.2844C0.708314 10.2844 0.140625 9.71669 0.140625 9.01641C0.140625 8.31613 0.708314 7.74844 1.40859 7.74844L7.74844 7.74717V1.40859C7.74844 0.708314 8.31613 0.140625 9.01641 0.140625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.cdf872c6c94e4a3d1f0c0a3089c9fede.svg";
export { ForwardRef as ReactComponent };